var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "0.24rem" } },
        [
          _c(
            "el-checkbox-group",
            {
              staticStyle: { "margin-bottom": "0.24rem" },
              on: {
                change: function ($event) {
                  ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                },
              },
              model: {
                value: _vm.init.q.invoicingKinds,
                callback: function ($$v) {
                  _vm.$set(_vm.init.q, "invoicingKinds", $$v)
                },
                expression: "init.q.invoicingKinds",
              },
            },
            _vm._l(_vm.checkData, function (item) {
              return _c(
                "el-checkbox",
                { key: item.label, attrs: { label: item.label } },
                [_vm._v(_vm._s(item.value) + " ")]
              )
            }),
            1
          ),
          _c("div", { staticClass: "center" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "0.12rem",
                },
              },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("订单编号:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "订单编号", size: "small" },
                  model: {
                    value: _vm.init.q.orderNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "orderNumber", $$v)
                    },
                    expression: "init.q.orderNumber",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("团号:")]),
                _c("el-input", {
                  staticStyle: { width: "0.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "团号", size: "small" },
                  model: {
                    value: _vm.init.q.planId,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "planId", $$v)
                    },
                    expression: "init.q.planId",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("申请日期:")]),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.05rem", width: "1.5rem" },
                  attrs: {
                    placeholder: "申请日期",
                    size: "small",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                  },
                  on: {
                    change: function ($event) {
                      ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                    },
                  },
                  model: {
                    value: _vm.init.q.createTimeStr,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "createTimeStr", $$v)
                    },
                    expression: "init.q.createTimeStr",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票金额:")]),
                _c("el-input", {
                  staticStyle: { width: "1.1rem", "margin-right": "0.1rem" },
                  attrs: {
                    placeholder: "发票金额",
                    size: "small",
                    type: "number",
                  },
                  model: {
                    value: _vm.init.q.fapPrice,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "fapPrice", $$v)
                    },
                    expression: "init.q.fapPrice",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("抬头类型:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "抬头类型", size: "small" },
                  model: {
                    value: _vm.init.q.lookUp,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "lookUp", $$v)
                    },
                    expression: "init.q.lookUp",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("稅号:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "稅号", size: "small" },
                  model: {
                    value: _vm.init.q.duty,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "duty", $$v)
                    },
                    expression: "init.q.duty",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票号码:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "发票号码", size: "small" },
                  model: {
                    value: _vm.init.q.fpNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "fpNumber", $$v)
                    },
                    expression: "init.q.fpNumber",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "align-items": "center" } },
              [
                _c("p", { staticClass: "p1" }, [_vm._v("发票内容:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "发票内容", size: "small" },
                  model: {
                    value: _vm.init.q.remark,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "remark", $$v)
                    },
                    expression: "init.q.remark",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("发票备注:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "发票备注", size: "small" },
                  model: {
                    value: _vm.init.q.invoicingRemark,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "invoicingRemark", $$v)
                    },
                    expression: "init.q.invoicingRemark",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("开票日期:")]),
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "0.1rem", width: "1.5rem" },
                  attrs: {
                    placeholder: "开票日期",
                    size: "small",
                    type: "date",
                    "value-format": "yyyy-MM-dd",
                  },
                  on: {
                    change: function ($event) {
                      ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                    },
                  },
                  model: {
                    value: _vm.init.q.invoicingTimeStr,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "invoicingTimeStr", $$v)
                    },
                    expression: "init.q.invoicingTimeStr",
                  },
                }),
                _c("p", { staticClass: "p1" }, [_vm._v("收款状态:")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                    attrs: { placeholder: "收款状态", size: "small" },
                    on: {
                      change: function ($event) {
                        ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                      },
                    },
                    model: {
                      value: _vm.init.q.linkStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.init.q, "linkStatus", $$v)
                      },
                      expression: "init.q.linkStatus",
                    },
                  },
                  _vm._l(_vm.options1, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("p", { staticClass: "p1" }, [_vm._v("开票状态:")]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                    attrs: { placeholder: "开票状态", size: "small" },
                    on: {
                      change: function ($event) {
                        ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                      },
                    },
                    model: {
                      value: _vm.init.q.kpStatus,
                      callback: function ($$v) {
                        _vm.$set(_vm.init.q, "kpStatus", $$v)
                      },
                      expression: "init.q.kpStatus",
                    },
                  },
                  _vm._l(_vm.options2, function (item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value },
                    })
                  }),
                  1
                ),
                _c("p", { staticClass: "p1" }, [_vm._v("申请人:")]),
                _c("el-input", {
                  staticStyle: { width: "1.6rem", "margin-right": "0.1rem" },
                  attrs: { placeholder: "申请人", size: "small" },
                  model: {
                    value: _vm.init.q.createName,
                    callback: function ($$v) {
                      _vm.$set(_vm.init.q, "createName", $$v)
                    },
                    expression: "init.q.createName",
                  },
                }),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.init.q.page = 1
                        _vm.getQueryInvoiceList()
                      },
                    },
                  },
                  [_vm._v("搜索 ")]
                ),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.resetClick } },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c(
              "el-radio-group",
              {
                attrs: { fill: "#E69C37", size: "small", "text-color": "#fff" },
                on: {
                  change: function ($event) {
                    ;(_vm.init.page = 1), _vm.getQueryInvoiceList()
                  },
                },
                model: {
                  value: _vm.init.q.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.init.q, "status", $$v)
                  },
                  expression: "init.q.status",
                },
              },
              _vm._l(_vm.radioList, function (item) {
                return _c(
                  "el-radio-button",
                  { key: item.name, attrs: { label: item.code } },
                  [_vm._v(_vm._s(item.name) + " ")]
                )
              }),
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { color: "#000" },
            "span-method": _vm.objectSpanMethod,
            border: "",
            "show-overflow-tooltip": "",
            "tooltip-effect": "dark",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "left",
              prop: "pId",
              type: "selection",
              width: "55",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "left",
              label: "订单编号",
              prop: "pId",
              width: "160",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.orderIds, function (item, index) {
                    return _c("p", { key: index }, [
                      _vm._v(" " + _vm._s(item) + " "),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "left",
              label: "申请日期",
              prop: "createTime",
              width: "170",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "团号", prop: "pId", width: "50" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.planId) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "left",
              label: "发票类型",
              prop: "invoicingRemark",
              "show-overflow-tooltip": "",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        style: {
                          color:
                            scope.row.invoicingType === 2 ||
                            scope.row.invoicingType === 3
                              ? "red"
                              : "",
                        },
                      },
                      [_vm._v(_vm._s(_vm.invoiceType[scope.row.invoicingType]))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "发票金额",
              prop: "invoicingRemark",
              "show-overflow-tooltip": "",
              width: "120",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", { staticStyle: { color: "rgb(216, 27, 67)" } }, [
                      _vm._v(_vm._s("¥" + scope.row.price)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "抬头",
              prop: "lookUp",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "税号",
              prop: "duty",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "发票号码",
              prop: "fpNumber",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "发票内容",
              prop: "remark",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "发票备注",
              prop: "pId",
              "show-overflow-tooltip": "",
              width: "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.invoicingRemark) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "开票时间",
              prop: "createTime",
              "show-overflow-tooltip": "",
              width: "150",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "收款状态",
              prop: "linkStatus",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.linkStatusMap[scope.row.linkStatus]) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "开票状态", width: "250" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      { attrs: { type: _vm.statusMap[scope.row.status].type } },
                      [_vm._v(_vm._s(_vm.statusMap[scope.row.status].text))]
                    ),
                    !scope.row.status && scope.row.fileUrl
                      ? _c("span", [_vm._v("（已产生开票信息）")])
                      : _vm._e(),
                    scope.row.status == 2
                      ? _c("div", [
                          _vm._v(
                            " 驳回理由：" + _vm._s(scope.row.rejectReason) + " "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "申请人",
              prop: "pId",
              "show-overflow-tooltip": "",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.createName) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "下载",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: !scope.row.fileUrl,
                          size: "mini",
                          type: "success",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.downloadFile(
                              scope.row.fileUrl,
                              scope.row.fileKey
                            )
                          },
                        },
                      },
                      [
                        _vm._v("发票下载 "),
                        _c("a", { attrs: { id: "d" + scope.$index } }),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "撤回",
              prop: "pId",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.datas
                            .find((n) => n.id === scope.row.pId)
                            .invoicingDetailList.some(
                              (n) =>
                                n.status === 1 || n.fileUrl || n.status === 2
                            ),
                          size: "mini",
                          type: "primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.withdraw(scope.row.pId)
                          },
                        },
                      },
                      [_vm._v("发票撤回 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "作废",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          disabled: scope.row.status === 1,
                          content: "后台设置成已开票,才能申请发票作废",
                          effect: "dark",
                          placement: "top-start",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.status !== 1,
                              size: "mini",
                              type: "warning",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.invoiceVoid(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("申请发票作废 ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              fixed: "right",
              label: "关联操作",
              "show-overflow-tooltip": "",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.changeAssociation(
                              scope.row.id,
                              scope.row.price,
                              scope.row.planId
                            )
                          },
                        },
                      },
                      [_vm._v("更改关联 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Pagination", {
        attrs: {
          currentPage: _vm.init.page,
          pageSizes: _vm.pageSizes,
          parentPageSize: 10,
          totalNumber: _vm.AllpagesNum,
        },
        on: { loadTable: _vm.loadTable },
      }),
      _c("changeAssociationPopup", {
        ref: "changeAssociationPopup",
        on: { update: _vm.getQueryInvoiceList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }